<ng-container *ngIf="since; else until">
  {{ timeTicker$ | async | ago : { maxParts: maxParts, suffix: '', showSeconds: true, shortNames: false } }}
</ng-container>
<ng-template #until>
  {{ timeTicker$ | async | fromNow : { maxParts: maxParts, suffix: '', showSeconds: true, shortNames: false } }}
</ng-template>
